import { useState } from 'react'
import {
  ElementAuthContext,
  useElementAuthProvider
} from './store'
import { ElementAppShell } from './components/layout'
import { ElementLoginPage } from './pages/Login'
import { ElementInboxPage } from './pages/Inbox'
import { ElementDomainsPage } from './pages/Domains'
import { ElementSettingsPage } from './pages/Settings'

type ElementActivePage = 'inbox' | 'domains' | 'settings'

function ElementAuthenticatedApp() {
  const [elementActivePage, setElementActivePage] = useState<ElementActivePage>('inbox')
  function renderElementActivePage() {
    switch (elementActivePage) {
      case 'inbox':
        return <ElementInboxPage />
      case 'domains':
        return <ElementDomainsPage />
      case 'settings':
        return <ElementSettingsPage />
      default:
        return <ElementInboxPage />
    }
  }

  return (
    <ElementAppShell>
      <div className="element-page-navigation">
        <button
          className={`element-nav-button ${elementActivePage === 'inbox' ? 'element-nav-button--active' : ''}`}
          onClick={() => setElementActivePage('inbox')}
        >
          Inbox
        </button>
        <button
          className={`element-nav-button ${elementActivePage === 'domains' ? 'element-nav-button--active' : ''}`}
          onClick={() => setElementActivePage('domains')}
        >
          Domains
        </button>
        <button
          className={`element-nav-button ${elementActivePage === 'settings' ? 'element-nav-button--active' : ''}`}
          onClick={() => setElementActivePage('settings')}
        >
          Settings
        </button>
      </div>
      {renderElementActivePage()}
    </ElementAppShell>
  )
}

export function ElementApp() {
  const elementAuthProviderValue = useElementAuthProvider()

  return (
    <ElementAuthContext.Provider value={elementAuthProviderValue}>
      {elementAuthProviderValue.isAuthenticationLoading ? (
        <div className="element-app-loading">
          <div className="element-app-loading-indicator">Loading Element Mail...</div>
        </div>
      ) : elementAuthProviderValue.authenticatedMailbox ? (
        <ElementAuthenticatedApp />
      ) : (
        <ElementLoginPage />
      )}
    </ElementAuthContext.Provider>
  )
}
